import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { watch } from 'vue'
import SiteAyarService from "@/services/site_ayar.ts";

import tr from '../locales/tr.json'
import en from '../locales/en.json'
import ky from '../locales/ky.json'
import bs from '../locales/bs.json'
import fa from '../locales/fa.json'
import sq from '../locales/sq.json'
import ar from '../locales/ar.json'
import fr from '../locales/fr.json'
import ta from '../locales/ta.json'
import nl from '../locales/nl.json'
import ru from '../locales/ru.json'
import ur from '../locales/ur.json'
import de from '../locales/de.json'
import id from '../locales/id.json'
import ms from '../locales/ms.json'

const browserDil = (navigator.language || '').split('-')[0]?.toLowerCase()
const storedDil = (localStorage.getItem('locale') || '').toLowerCase()
const varsayilanDil = storedDil || browserDil || 'en'

const i18n = createI18n({
  legacy: false,
  locale: varsayilanDil,
  fallbackLocale: 'en',
  messages: { tr, en, ky, bs, fa, sq, ar, fr, ta, nl, ru, ur, de, id, ms },
})

// siteAyar async olarak alınıp locale güncellenir
async function initLocale() {
  const [err, siteAyar] = await SiteAyarService.getSiteAyar()
  if (err) {
    console.error('Error getting site ayar: ', err)
    return
  }

  const diller = (siteAyar?.language_list || []).map((l: string) => l.toLowerCase())
  if (diller.length === 0) return

  const ilkDil = diller[0]
  const seciliDil = diller.length === 1
    ? ilkDil
    : diller.find(d => d === storedDil) || diller.find(d => d === browserDil) || ilkDil

  if (seciliDil && seciliDil !== i18n.global.locale.value) {
    i18n.global.locale.value = seciliDil as typeof i18n.global.locale.value
  }
}

initLocale()

export function setupI18n(app: App) {
  app.use(i18n)
}

export { i18n }

const rtlLocales = ['ar', 'fa', 'ur']

watch(
  () => i18n.global.locale.value,
  (locale) => {
    const html = document.documentElement
    html.lang = locale
    html.dir = rtlLocales.includes(locale) ? 'rtl' : 'ltr'
  },
  { immediate: true }
)
